import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { SessionUserSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { selectSpaceInfo } from '~src/app/selectors/SpaceInfoSelectors';

import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '../../../actions/UpdateBreadcrumbsAction';
import { selectContentTotalLength } from '../../../selectors/ContentSelectors';
import { AppState } from '../../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../../utils/ConnectUtils';
import { AllSiteUsersAndIdentitiesSpace,AllSiteUsersAndIdentitiesSpaceDispatchProps,AllSiteUsersAndIdentitiesSpaceOwnProps, AllSiteUsersAndIdentitiesSpaceStateProps } from './AllSiteUsersAndIdentitiesSpace';

const mapStateToProps: MapStateToProps<AllSiteUsersAndIdentitiesSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  numberOfFetchedUsers: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,

  isSessionMultiSite: SessionUserSelectors.isSessionMultiSite(state),
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
  canSessionUserManageUsers: SessionUserSelectors.canManageUsers(state),
});

const mapDispatchToProps: MapDispatchToProps<AllSiteUsersAndIdentitiesSpaceDispatchProps> = (dispatch) => bindActionCreators({
    requestSpaceContents,
    updateBreadcrumbs
  }, dispatch);

export const ConnectedAllSiteUsersAndIdentitiesSpace: React.ComponentClass<AllSiteUsersAndIdentitiesSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllSiteUsersAndIdentitiesSpace);
